import { AccountService } from "../../services/account.service";
import store from '../../store';
import { } from 'vue-router';
import * as AccountTypes from '../../store/app/account/types';
import { JSONX } from "../../utility";
import { PermissionRouteMap } from "./permissions";
import { NotificationService } from "../../dt-plugins/notification/notification.service";
import { SessionManager } from './session';
import { values, flatten, toPairs } from 'ramda';
import { SET_LOGIN_REDIRECT_ROUTE } from '../../store/app/types';

export const RouteGuard = (to, from, next) => {
  // console.log("to.path", to.path, checkPermission);
  if (checkPermission(to.path)) {
    next();
    if (
      ![
        '/main/home',
        '/main/login',
        '/main/shared-login',
        '/main/payment-fail',
      ].includes(to.path)
    ) {
      SessionManager.setLastValidRoute(to.path);
    }
  } else {
    // console.error('That Route is Blocked');
    NotificationService.showNotification({
      text: `The URL - ${to.path} is blocked for you`,
      timeout: 3000,
      type: 'error'
    }).then();
  }
}

export let checkPermission = (route) => {
  return true;
};

export let UserPermission = undefined;

const paywall_route = '/main/paywall';

export const initOutMainComponentRoute = (to, from, next) => {
  const account = store.getters.account;

  console.log({ account });

  // First Initial Call of InitMainRoute
  if (!account) {
    store.dispatch(AccountTypes.GET_APP_INIT_DATA).then((appData) => {
      // console.error('userInfo', userInfo);

      const { paywall_block, shared_login_block } = appData;

      handlePermissions(appData, to, next);

      if (!(paywall_block || shared_login_block)) {
        next(getNextValidRoute());
        return;
      }
    });
  }

  else {
    next();
  }
}

export const InitMainRoute = (to, from, next) => {

  console.log('InitMainRoute', to);

  // Setting the First Redirection Route to the InitMainRoute Call
  // Necessary to Re Route to the Original UnAuthenticated Route Access
  if (to.name !== 'mainLogin') {
    store.dispatch(SET_LOGIN_REDIRECT_ROUTE, to);
  }


  const account = store.getters.account;

  if (account) {
    const { paywall_block, shared_login_block } = account;
    if (!(paywall_block || shared_login_block)) {
      next();
      return;
    }
  }
  // First Initial Call of InitMainRoute
  // if (!account) {
  store.dispatch(AccountTypes.GET_APP_INIT_DATA).then((appData) => {
    // console.error('userInfo', userInfo);

    const { paywall_block, shared_login_block } = appData;

    console.log({ paywall_block });

    const paywall_route = '/main/payment-fail';
    const shared_login_route = '/main/shared-login';
    console.log({ shared_login_block, 'index.js:92 shared_login_route': shared_login_route });

    if (paywall_block && to.path !== paywall_route) {
      store.commit(AccountTypes.SET_ROUTE_BEFORE_BLOCK, to.path);
      // console.log('route before Block', to.path);
      next(paywall_route);
      return;
    }

    if (shared_login_block && to.path !== shared_login_route) {
      store.commit(AccountTypes.SET_ROUTE_BEFORE_BLOCK, to.path);
      // console.log('route before Block', to.path);
      next(shared_login_route);
      return;
    }

    // if (display_notice_block) {
    //   console.log({
    //     ...to,
    //     query: {
    //       modal: 'welcome_notice'
    //     },
    //   }, next);
    // }
    handlePermissions(appData, to, next);
  })
  // } else {

  // }
}

export const getNextValidRoute = () => {
  for (const route of values(PermissionRouteMap.sub_menu)) {
    // console.log(route);
    if (checkPermission(route)) {
      return route;
    }
  }
  return '/main/home';
}

export const lastValidRouteOrHome = () => {
  const validRoute = SessionManager.getLastValidRoute();
  if (validRoute && checkPermission(validRoute)) {
    return validRoute;
  }
  return '/main/home';
}

export const checkModulePermission = (moduleRoute) => {
  const account = store.getters.account;
  // console.log('account', account)
  return checkPermission(`/main/${moduleRoute}`);
}

export const checkSubmenuPermission = (moduleRoute, submenuRoute) => {
  return checkPermission(`/main/${moduleRoute}/${submenuRoute}`);
}
export const checkTabPermission = (moduleRoute, submenuRoute, tabRoute) => {
  return checkPermission(`/main/${moduleRoute}/${submenuRoute}/$/${tabRoute}`);
}


export const checkTabListPermission = (moduleRoute, submenuRoute, tabList) => {
  return tabList.filter(tab => {
    if (checkTabPermission(moduleRoute, submenuRoute, tab.route)) {
      return true;
    }
    return false;
  })
}

export const checkTabGridItemPermission = (moduleRoute, submenuRoute, gridLayout, gridRouteMap) => {
  const blockedGridItems = flatten(toPairs(gridRouteMap).filter(pair => !checkTabPermission(moduleRoute, submenuRoute, pair[0])).map(pair => pair[1]));
  // console.log(blockedGridItems, gridLayout, gridLayout.layout.filter((e, i) => blockedGridItems.includes(i)));
  gridLayout.layout = gridLayout.layout.filter((e, i) => !blockedGridItems.includes(i))

  return gridLayout
}

export const NOMATCH = 'NOMATCH';

export const getPermissionRegularExpressions = (perm, isProject = false) => {
  const label = perm?.modules?.find(m => m === 'label');
  if (label) {
    perm.modules = [
      ...perm.modules,
      ...['catalog', 'royalty', 'licencing']
    ]
  }
  if (isProject) {
    perm.sub_menu = perm.sub_menu ? perm.sub_menu : [];
    perm.sub_menu = [
      ...perm.sub_menu,
      ...['projects']
    ]
  }


  return [
    ...values(perm.modules).map(p => {
      // console.log(PermissionRouteMap.modules[p]);
      return new RegExp(PermissionRouteMap?.modules?.[p] ?? NOMATCH);
    }),
    ...values(perm.sub_menu).map(p => {
      // console.log(PermissionRouteMap.sub_menu[p]);
      return new RegExp(PermissionRouteMap?.sub_menu?.[p] ?? NOMATCH);
    }),
    ...values(perm.tabs).map(p => {
      // console.log(PermissionRouteMap.tabs[p].replace(/\$/g, '.*'));
      return new RegExp((PermissionRouteMap?.tabs?.[p] ?? NOMATCH).replace(/\/\$/g, '.*'));
    }),
  ]
}

export const testRoutePermission = (route) => {
  const blocked = getPermissionRegularExpressions(userPerm)
    .map(r => r.exec(route))
    .filter(r => r);

  return blocked && blocked.length > 0;
}
export const createPermissionChecker = (permRgxs) => (route) => {
  const blocked = permRgxs.map(r => r.exec(route))
    .filter(r => r);

  // console.log("blocked", blocked);
  // console.log("permRgxs", permRgxs);
  return (blocked && blocked.length > 0) ? false : true;
}

function handlePermissions(appData, to, next) {
  const { settings_label_projects } = appData.client;
  const { result } = JSONX.tryParse(appData?.user?.permissions);
  UserPermission = result?.blocked;
  const isProject = settings_label_projects === 1 ? false : true;
  if (result?.blocked) {
    checkPermission = createPermissionChecker(getPermissionRegularExpressions(result.blocked, isProject));
  }
  if (checkPermission(to.path)) {
    next();
  } else {
    NotificationService.showNotification({
      text: `The URL - ${to.path} is blocked for you`,
      timeout: 3000,
      type: 'error'
    }).then();

    const validRoute = SessionManager.getLastValidRoute();
    if (validRoute && checkPermission(validRoute)) {
      next(validRoute);
    } else {
      next(getNextValidRoute());
    }
  }
}

